import { render, staticRenderFns } from "./RepairManage.vue?vue&type=template&id=520327c0&scoped=true"
import script from "./RepairManage.vue?vue&type=script&lang=js"
export * from "./RepairManage.vue?vue&type=script&lang=js"
import style0 from "./RepairManage.vue?vue&type=style&index=0&id=520327c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520327c0",
  null
  
)

export default component.exports